<template>
  <div class="main">
    <Header 
      :show="true"
      title="物料列表"
      left="prepage" 
      right="create" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="管理物料信息"
      />
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{row}">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="名称">
                <span>{{ row.name }}</span>
              </el-form-item>
              <el-form-item label="类别">
                <span v-if="row.type === '骨料'">骨料</span>
                <span v-else-if="row.type === '粉料'">粉料</span>
                <span v-else>其他</span>
              </el-form-item>
              <el-form-item label="规格">
                <span>{{ row.standard }}</span>
              </el-form-item>
              <el-form-item label="单位">
                <span>{{ row.unit }}</span>
              </el-form-item>
              <el-form-item label="说明">
                <span>{{ row.remark }}</span>
              </el-form-item>
              <!-- <el-form-item label="库存">
                <span>{{ row.stock }}</span>
              </el-form-item> -->
              <el-form-item
                v-if="checkPermission([203]) || checkPermission([204]) || checkPermission([205])"
                label="操作"
              >
                <!-- <el-button v-if="checkPermission([205])" type="warning" size="mini" @click="handleClickUpdateStock(row)">
                  盘点
                </el-button> -->
                <el-button
                  v-if="checkPermission([203])"
                  type="primary"
                  size="mini"
                  @click="handleClickUpdate(row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="checkPermission([203])"
                  type="danger"
                  size="mini"
                  @click="handleClickDelete(row)"
                >
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          width="60"
        >
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column
          label="类别"
          prop="type"
          align="center"
          show-overflow-tooltip
          width="80"
        >
          <template slot-scope="{row}">
            <el-tag
              v-if="row.type === '骨料'"
              type="success"
            >
              骨料
            </el-tag>
            <el-tag
              v-else-if="row.type === '粉料'"
              type="primary"
            >
              粉料
            </el-tag>
            <el-tag
              v-else
              type="info"
            >
              其他
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="名称"
          prop="name"
          align="center"
          show-overflow-tooltip
          min-width="100"
        >
          <template slot-scope="{row}">
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="说明"
          prop="remark"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.remark }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination 
        v-show="table.total>0" 
        :total="table.total" 
        background 
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #FFFFFF;" />
      
      <van-dialog
        v-model="dialogVisibleUpdateStock" 
        title="料仓盘点"
        show-cancel-button
        :before-close="handleClickUpdateStockConfirm"
      >
        <van-field
          ref="name"
          v-model="listQuery.name"
          label="物料名称"
          placeholder="请选择物料名称"
          required
          readonly
        />
        <van-field
          ref="stock"
          v-model="listQuery.stock"
          label="当前库存"
          placeholder="请输入当前库存"
          required
          :rules="[{ validator: validNumberFloat, message: '' }]"
        />
      </van-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isNumberFloat } from '@/utils/validate.js'
  import { getList, deleteOne, updateOne } from '@/api/material.js'

  export default {
    name: "ServiceSystemMaterial",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisibleUpdateStock: false,
        listQuery: {
          limit: 10,
          page: 1,
          serial: null,
          name: '',
          stock: 0
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        },
        loading: false
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {
      
    },
    mounted() {
      
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({ 
          path:'/service/system/material/create', 
          query: {} ,
        })
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          showPhoneAlarm(true, 'toast', null, 2000, null, '工程配置', '刷新完成')
        }, 1000)
      },
      validNumberFloat(value) {
        return new Promise((resolve) => {
          const result = isNumberFloat(value)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              let type = '其他'
              if (items[i].type === 1) {
                type = '骨料'
              } else if (items[i].type === 2) {
                type = '粉料'
              }
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                name: items[i].name,
                type: type,
                standard: items[i].standard,
                unit: items[i].unit,
                stock: items[i].stock,
                remark: items[i].remark
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdateStock(row) {
        this.listQuery.serial = row.serial
        this.listQuery.name = row.name
        this.listQuery.stock = row.stock
        this.dialogVisibleUpdateStock = true
      },
      handleClickUpdateStockConfirm(action, done) {
        if (action === 'confirm') {
          const data = {
            id: this.listQuery.serial,
            stock: this.listQuery.stock
          }
          this.loading = true
          updateOne(data).then(response => {
            const { data } = response
            showPhoneAlarm(true, 'toast', null, 2000, data.code, '料仓盘点', data.message)
            this.handleClickQuery()
            this.dialogVisibleUpdateStock = false
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        } else {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, null, '取消盘点')
          done(true)
        }
      },
      handleClickUpdate(row) {
        this.$router.push({ path:'/service/system/material/update', query: row })
      },
      handleClickDelete(row) {
        Dialog.confirm({
          title: '确认删除物料信息？',
          message: '物料：' + row.name,
        }).then(() => {
          this.loading = true
          const data = {
            id: row.serial
          }
          deleteOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '删除', data.message)) {
              this.loading = false
              this.table.data.splice(this.table.data.indexOf(row), 1)
            }
          }).catch(function(error) {
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '删除', '取消')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 30%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
